// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nZwN","textarea":"styles_textarea__3wznw"};